class Svg {
    constructor(url) {
        let div = document.createElement('div');

        div.innerHTML = url;

        let fragment = document.createDocumentFragment();
        fragment.appendChild(div);

        this.svg = fragment.querySelector('svg');
    }

    classes(classes) {
        if (classes) {
            this.svg.classList.add(classes);
        }

        return this;
    }

    width(width) {
        if (width) {
            this.svg.setAttribute('width', width);
        }

        return this;
    }

    height(height) {
        if (height) {
            this.svg.setAttribute('height', height);
        }

        return this;
    }

    toString() {
        return this.svg.outerHTML;
    }
}

export default {
    props: ['url', 'classes', 'width', 'height'],

    render(h) {
        return h('div', {
            domProps: {
                innerHTML: new Svg(this.url)
                    .classes(this.classes)
                    .width(this.width)
                    .height(this.height)
            }
        });
    }
}
